import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useCurrency } from '../contexts/CurrencyContext';
export function FinalCTA() {
  const ref = useRef(null);
  const {
    formatPrice
  } = useCurrency();
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-24 px-4 md:px-6 text-center max-w-3xl mx-auto" data-id="element-49">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {
      opacity: 0,
      y: 30
    }} transition={{
      duration: 0.8
    }} data-id="element-50">
        <h2 className="font-serif text-3xl md:text-5xl font-bold text-charcoal mb-8 leading-tight" data-id="element-51">
          If you're tired of buying gifts that disappear…
        </h2>

        <p className="text-xl text-warm-gray mb-12" data-id="element-52">
          Give them something they can actually use. <br data-id="element-53" />
          Not another object. <br data-id="element-54" />
          <span className="text-coral font-bold font-serif text-2xl block mt-4" data-id="element-55">
            A claim on you.
          </span>
        </p>

        <a href="https://www.gemmamama.com/cart/45506271477899:1" target="_blank" rel="noopener noreferrer" className="bg-charcoal hover:bg-black text-white text-lg md:text-xl font-semibold px-10 py-5 rounded-full shadow-xl transition-all transform hover:-translate-y-1 flex items-center justify-center gap-3 mx-auto" data-id="element-56">
          <span data-id="element-57">
            Download "Grandma & Me" —{' '}
            <span className="line-through opacity-60 text-base" data-id="element-58">
              {formatPrice(15.99)}
            </span>{' '}
            {formatPrice(6.39)}
          </span>
          <span className="bg-coral text-white text-xs font-bold px-2 py-1 rounded-full" data-id="element-59">
            60% OFF
          </span>
        </a>

        <p className="mt-8 text-sm text-warm-gray" data-id="element-60">
          Give them the kind of gift that turns into a tradition.
        </p>
      </motion.div>
    </section>;
}